import { Link } from "@mui/material";

const CatalogColumns = () => {
    return [
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            renderCell: ({ row: { _id, name } }) => (
                <Link
                    className="hive-grid-link-cell"
                    href={`/catalogs/${_id}`}
                    underline="none"
                    sx={{ color: 'rgb(70 128 255)', fontWeight: 500 }} // adjust color here rgb(70 128 255)
                >
                {name}
                </Link>
            )
        },
        {
            field: "createdBy",
            headerName: "Created By",
            flex: 1,
        },
        {
            field: "createdAt",
            headerName: "Date Created",
            flex: 1,
            renderCell: ({ row: { createdAt } }) => {
                if (!createdAt) return "";
                const date = typeof createdAt === "string" ? new Date(createdAt) : createdAt;
                return date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
            },            
        },
        {
            field: "updatedAt",
            headerName: "Last Updated",
            flex: 1,
            renderCell: ({ row: { updatedAt } }) => {
                if (!updatedAt) return "";
                const date = typeof updatedAt === "string" ? new Date(updatedAt) : updatedAt;
                return date.toISOString().split("T")[0]; // 'YYYY-MM-DD'
            },              
        },
        {
            field: "products",
            headerName: "Total Items",
            flex: 1,
            renderCell: ({ row: { products } }) => {
                if (!products) return "0";
                return products.length
            },       
        }
    ]
}

export default CatalogColumns
